import { attr } from '@ember-data/model';
import BaseModel from 'volta/models/base-model';
import type { TAcquisitionCode } from 'volta/models/constants/acquisition-codes';
import type { TLeadTimeCategory } from 'volta/models/constants/lead-time-categories';
import type { TVarCategory } from 'volta/models/constants/var-categories';
import { _normalize, collectionCommand, resourceCommand } from 'volta/utils/api';
import type { TAduType } from './types/planning-settings';
import { Type } from '@warp-drive/core-types/symbols';

export const ResourceName = {
  singular: 'aduProfile',
  plural: 'aduProfiles'
};

export const Commands = {
  CreateAduProfile: 'CreateAduProfile',
  UpdateAduProfile: 'UpdateAduProfile'
};
export default class AduProfile extends BaseModel {
  // Collection commands
  // ~~~~~

  static createAduProfile = collectionCommand<any, AduProfile>(Commands.CreateAduProfile);

  // Properties
  // ~~~~~

  @attr('string') declare code: string;
  @attr('string') description?: string;
  @attr('number') aduOverride?: number;
  @attr('number') aduMin?: number;
  @attr('string', { defaultValue: 'ROLLING' }) declare aduType: TAduType;
  @attr('number') aduHorizon?: number;
  @attr('number') aduHorizonOffset?: number;
  @attr('boolean', { defaultValue: false }) declare discontinuedDemand: boolean;
  @attr('string') varCategory?: TVarCategory;
  @attr('string') leadTimeCategory?: TLeadTimeCategory;
  @attr('string') acqCode?: TAcquisitionCode;
  @attr('boolean', { defaultValue: false }) declare isDefault: boolean;
  @attr('array', {
    defaultValue: () => []
  })
  declare tags: string[];

  // Computed Properties
  // ~~~~~

  get aduProfileId() {
    return this.id;
  }

  // Commands
  // ~~~~~

  updateAduProfile = resourceCommand<any, AduProfile>('UpdateAduProfile');

  [Type] = 'adu-profile' as const;
}
